import { Controller } from "@hotwired/stimulus";

// Shows/hides the shared #loading_banner (see layouts/application.html.erb)
// while a Turbo form submission or visit is in flight.
export default class extends Controller {
  show() {
    document.getElementById("loading_banner")?.classList.remove("hidden");
  }

  hide() {
    document.getElementById("loading_banner")?.classList.add("hidden");
  }
}
